import React from 'react';
import {connect} from 'react-redux';
import Preloader from 'components/molecules/preloader/mobile';
import Lineup from 'components/organisms/lineup/mobile';
import {BaseLineupsList} from './base-lineups-list';

class MobileLineupsList extends BaseLineupsList {
    render() {
        const {lineups} = this.props;

        let content = lineups.loading ? <Preloader /> : '';

        const lineupsToRender = this.getLineupsToRender();

        if (!isEmpty(lineupsToRender)) {
            const lineups = lineupsToRender.map((lineup, i) => <Lineup key={i} lineupId={lineup.lineupId} index={i} />);

            content = this.getLineupsListView(lineups);
        } else if (lineups.loaded && !lineups.loading && isEmpty(lineupsToRender)) {
            content = this.getLineupsNotFoundView({className: 'lineup-box'});
        }

        return <div>{content}</div>;
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups, status, filters},
        filterLineupsByPlayer,
        filterLineupsByTeamCombinations,
        filterLineupsByCorrelationStackCombinations,
        filterLineupsByKeyPlayerStackCombinations,
    } = state;

    return {
        lineups,
        status,
        filters,
        filterLineupsByPlayer,
        filterLineupsByTeamCombinations,
        filterLineupsByCorrelationStackCombinations,
        filterLineupsByKeyPlayerStackCombinations,
    };
}

const MobileLineupsListComponent = connect(mapStatesToProps)(MobileLineupsList);

export {MobileLineupsListComponent};
